export default "__VITE_ASSET__CVY3awvE__"